export const extractHostname = (url) => {
  //find & remove protocol (http, ftp, etc.) and get hostname
  const hostname = url.split('/')[2];

  //find & remove port number and "?"
  return hostname.split(':')[0].split('?')[0];
};

export const extractRootDomain = (url) => {
  const domain = extractHostname(url);
  const parts = domain.split('.');

  //extracting the root domain here
  return `${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
};

export default {
  extractHostname,
  extractRootDomain,
};
